import { render, staticRenderFns } from "./ColmenarNuevo.vue?vue&type=template&id=372067f8&"
import script from "./ColmenarNuevo.vue?vue&type=script&lang=js&"
export * from "./ColmenarNuevo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports